import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  fullWidth?: boolean;
  href?: string;
}
export function Button({
  children,
  fullWidth = false,
  className = '',
  href,
  ...props
}: ButtonProps) {
  const buttonClasses = `
    bg-[#C4A35A] text-white font-medium py-4 px-8 rounded-sm shadow-md 
    hover:bg-[#B8860B] transition-colors duration-300 flex items-center justify-center gap-2
    uppercase tracking-wide text-sm md:text-base
    ${fullWidth ? 'w-full' : 'w-auto'}
    ${className}
  `;
  if (href) {
    return <motion.a href={href} target="_blank" rel="noopener noreferrer" whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={buttonClasses} data-id="element-150">
        {children}
        <ArrowRight className="w-4 h-4" data-id="element-151" />
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={buttonClasses} {...props} data-id="element-152">
      {children}
      <ArrowRight className="w-4 h-4" data-id="element-153" />
    </motion.button>;
}